import ajax from '@/libs/api.request'

export default {
    getList : param => {
        return ajax.get('/edu/web/role/list', param)
    },

    getOne : param => {
        return ajax.get('/edu/web/role/findOneById', param)
    },

    save : param => {
        return ajax.post('/edu/web/role/save',param)
    },

    del : param => {
        return ajax.post('/edu/web/role/delete',param)
    },

    getAll:param => {
        return ajax.get('/edu/web/role/all', param)
    }

}

